export default {
  state: {
    accountErrorCode: 0,
    possessionParam: {}
  },
  mutations: {
    SETTING_ACCOUNT_ERROR_CODE(state, code) {
      state.accountErrorCode = code;
    },
    SET_ACCOUNT_POSSESSION(state, possessionParam) {
      state.possessionParam = possessionParam;
    }
  }
};
